import { api } from './client'

export type VersaoNaLista = {
  numero: number
  publicadaEm: string
  publicadaPor: string
  observacao: string | null
  impressao: string
}

/**
 * 🔴 `haDiferencaPendente` é o dado mais importante desta tela.
 *
 * Sem ele em lugar visível, o modo de falha é o oposto do que a demanda evita:
 * alguém muda uma regra, nada acontece no atendimento, e a conclusão é "a tela
 * está quebrada".
 */
export type SituacaoDaPublicacao = {
  versaoVigente: number | null
  publicadaEm: string | null
  publicadaPor: string | null
  haDiferencaPendente: boolean
}


/**
 * Uma divergência entre o que está gravado e o que o assistente usa (demanda 123).
 *
 * 🔴 `haDiferencaPendente` responde *se* algo está pendente. Não responde **o
 * quê** — que é a pergunta de quem acabou de gravar uma regra e quer saber se
 * foi a dele que não subiu.
 */
export type DiferencaPendente = {
  escopo: 'Regra' | 'Roteamento' | 'Assistente'
  chave: string
  rotulo: string
  assistenteId: number | null

  /** O que o assistente usa AGORA. Nulo quando o item não existia no retrato. */
  publicado: string | null

  /** O que está gravado e ainda não vale. Nulo quando o item foi apagado. */
  vivo: string | null

  /** Texto longo: os valores vêm como medida ("19.999 caracteres"), não como texto. */
  longo: boolean
}

export type Pendencias = {
  total: number
  itens: DiferencaPendente[]
}

export const publicacao = {
  situacao: () => api.get<SituacaoDaPublicacao>('/configuracao/versoes/situacao'),
  pendencias: () => api.get<Pendencias>('/configuracao/versoes/pendencias'),
  listar: () => api.get<VersaoNaLista[]>('/configuracao/versoes'),

  publicar: (observacao: string) =>
    api.post<{ publicada: boolean; numero?: number; motivo?: string }>('/configuracao/versoes', {
      observacao,
    }),

  restaurar: (numero: number) =>
    api.post<{ numero: number; observacao: string | null }>(
      `/configuracao/versoes/${numero}/restaurar`,
      {},
    ),
}
